module.exports = __webpack_public_path__ + "static/media/468x60_0014_en.85f08663.jpg";